import { TypedUseQueryHookResult } from '@reduxjs/toolkit/dist/query/react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { useGetConceptGroupsQuery } from '@verantos-dev/data-access-concept-groups';
import { type Cohort } from '@verantos-dev/types-cohorts';
import { ListResponse } from '@verantos-dev/types-common';

export const useConceptGroupDataGridFetch: TypedUseQueryHookResult<
  ListResponse<Cohort>,
  string | null,
  any,
  any
> = () => {
  return useGetConceptGroupsQuery(
    {},
    {
      // No standing poll (OR-6318 load amplifier). Mutations invalidate
      // CONCEPT_GROUP_TAG, so same-tab changes still refresh; external
      // changes surface on remount.
      refetchOnMountOrArgChange: true,
    }
  );
};
